import { makeAutoObservable, runInAction } from 'mobx';
import { sortBy } from 'lodash-es';

import { cmApi } from '@src/api';
import type { CmApi, FrequencyDto } from '@src/api';

import { preloaderStore } from '../../preloaderStore';

type FrequencyDtoDefId = FrequencyDto & { id: string };

class FrequenciesStore {
  frequencies: FrequencyDtoDefId[] = [];

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  fetch = async (): Promise<void> => {
    preloaderStore.preloader(true);

    const { data } = await this.api.frequency.getFrequencies();

    runInAction(() => {
      this.frequencies = sortBy(data?.map((frequency) => ({ ...frequency, id: frequency.code ?? '-1' })), 'code') ?? [];
    });
    preloaderStore.preloader(false);
  };
}

export const frequenciesStore = new FrequenciesStore({ api: cmApi });
